export default __webpack_public_path__ + "static/media/Arm.520133c6.png";